// Dates action types

const datesActionTypes = {
  UPDATE_DATES: 'UPDATE_DATES'
};

export default datesActionTypes;
